import { PanelSection, type PanelSectionProps } from '@dev-spendesk/grapes';
import cx from 'classnames';
import React from 'react';

type Props = PanelSectionProps & {
  isEmphasized?: boolean;
};

export function PanelTextSection({
  children,
  isEmphasized = false,
  ...panelSectionProps
}: Props) {
  return (
    <PanelSection {...panelSectionProps}>
      <div
        className={cx('text-content-primary body-m', {
          'rounded-8 bg-background-secondary-default px-12 py-[10px] text-content-secondary-bg-secondary':
            isEmphasized,
        })}
      >
        {children}
      </div>
    </PanelSection>
  );
}
